(function ($, Drupal) {
  // Handle cta button show and hide.
  var ctaButtonShowHide = function (context) {
    const articlesGridBlock = $('.block-articles-grid', context).find(
      '.block-articles-grid__articles'
    );
    const articleItems = articlesGridBlock.find(
      '.field--name-field-select-article > .field__item'
    );
    if (articleItems.length > 3 && !articlesGridBlock.hasClass('expanded')) {
      const cta = $('.block-articles-grid__cta');
      cta.removeClass('hide').addClass('show');
      if (articleItems.length < 6 && $(window).width() > 768) {
        cta.removeClass('show').addClass('hide');
      }
    }
  };
  Drupal.behaviors.articlesGrid = {
    attach: function (context, settings) {
      $(window).on('load resize', function () {
        ctaButtonShowHide(context);
      });
      $(document).ready(function () {
        const articlesGrid = $('.block-articles-grid', context).find(
          '.block-articles-grid__articles'
        );
        const articles = articlesGrid.find(
          '.field--name-field-select-article > .field__item'
        );
        const cta = $('.block-articles-grid__cta');
        cta.click(function () {
          articles.each(function () {
            $(this).addClass('show');
          });
          cta.removeClass('show').addClass('hide ');
          articlesGrid.addClass('expanded');
        });
      });
    },
  };
})(jQuery, Drupal);
